<bevme-header [showBack]="true" backRoute="/tabs/account"></bevme-header>

<ion-content class="faq-content">
  <div class="faq-wrap">
    <div class="faq-card">
      <div class="eyebrow">Help</div>
      <h1>Frequently Asked Questions</h1>

      <section class="faq-section">
        <h2>What is BevMe?</h2>
        <p>BevMe is an app to discover places and share reviews focused on matcha and, in the future, other beverages. You can explore nearby matcha spots, rate drinks, upload photos, and ❤️ favorite your go-to locations. Created by matcha lovers for matcha lovers.</p>
      </section>

      <section class="faq-section">
        <h2>Do I need an account to use the app?</h2>
        <p>To use all features in the app, yes. You need to log in to:</p>
        <ul>
          <li>Leave your own reviews</li>
          <li>Upload photos of matcha and cafes</li>
          <li>Save your activity</li>
          <li>Favorite locations</li>
        </ul>
        <p>In guest mode, you can only explore the map and see other people's reviews.</p>
      </section>

      <section class="faq-section">
        <h2>Why do I have to enter a code every time I log in?</h2>
        <p>We use passwordless login for security. A one-time code is sent to your email so you do not need to remember a password.</p>
      </section>

      <section class="faq-section">
        <h2>How is my review score calculated?</h2>
        <p>Reviews take into consideration the matcha grade, matcha prep, taste, and drink options available on the menu. We believe taste is the most important aspect, so it makes up 40% of your total score. The other 3 categories each make up 20% of the score.</p>
      </section>

      <section class="faq-section">
        <h2>Can I add a new place?</h2>
        <p>Yes. If a place is not listed, you can add it directly in the app. In Map view, tap the <strong>+</strong> button in the upper right corner. Type in the name of the cafe or restaurant and the address will be autofilled for you.</p>
        <p>If you are unable to find a place based on the name search, please let us know by using Report an Issue in the Account tab.</p>
      </section>

      <section class="faq-section">
        <h2>Why is some information missing or incorrect?</h2>
        <p>BevMe relies on user-generated content and third-party data, so some details may not always be perfect. We are constantly improving accuracy.</p>
        <p>If you find something incorrect, please let us know by using the Report an Issue feature in the Account tab.</p>
      </section>

      <section class="faq-section">
        <h2>Can I edit or delete my review?</h2>
        <p>Yes. You can update or delete your own reviews at any time from the My Reviews tab.</p>
      </section>

      <section class="faq-section">
        <h2>What kind of photos should I upload?</h2>
        <p>For the best matcha representation, we recommend uploading:</p>
        <ul>
          <li>The drink</li>
          <li>The presentation</li>
          <li>The vibe of the place</li>
        </ul>
        <p>Avoid uploading unrelated or inappropriate images to avoid your review and account being deactivated.</p>
        <p>Please report any inappropriate content using the flag button found next to each username, location name, or review.</p>
      </section>

      <section class="faq-section">
        <h2>Can I report a problem or inappropriate content?</h2>
        <p>Yes. If you see something that needs fixing or should not be on the app, please use the Report an Issue button in the Account tab, or contact us at <a href="mailto:hello@drinkbevme.com">hello@drinkbevme.com</a>.</p>
      </section>

      <section class="faq-section">
        <h2>Why is the map or data not loading?</h2>
        <p>This can happen if:</p>
        <ul>
          <li>Your internet connection is slow</li>
          <li>Location permissions are disabled</li>
        </ul>
        <p>Try:</p>
        <ul>
          <li>Refreshing the app</li>
          <li>Enabling location services</li>
          <li>Logging out and back in</li>
        </ul>
      </section>

      <section class="faq-section">
        <h2>Is BevMe free to use?</h2>
        <p>Yes, BevMe is currently free to use.</p>
      </section>

      <section class="faq-section">
        <h2>How do I delete my account?</h2>
        <p>Go to the Account tab and tap the Delete Account button.</p>
        <p>Deleting your account removes your personal profile information and signs you out. Your reviews may remain visible, but they will show as Deleted User instead of showing your name, username, or profile photo.</p>
        <p>This action is permanent and cannot be undone.</p>
      </section>
    </div>
  </div>
</ion-content>
